import * as gtm from './src/gtm';
import * as matomo from './src/matomo';
import $ from "jquery";
import {getPrefixedDataSet} from "../data-set-utils";

export const initGtmEventTracking = createEventTracking(gtm);
export const initMatomoEventTracking = createEventTracking(matomo);

function createEventTracking({
     setup,
     trackEvent
 }) {
    return ({
            dataAttributePrefix = 'event-tracking',
            debug = false
        } = {}) => {
        setup({debug});

        // todo repalce with onFind
        $(document.body).on('click', `[data-${dataAttributePrefix}-category]`, function () {
            let clickedElement = this;
            let $clickedElement = $(clickedElement);
            let data = {};

            if (clickedElement.tagName === 'A') {
                data.action = clickedElement.getAttribute('href');
                data.label = trim(clickedElement.textContent);
            }

            data = {
                ...data,
                ...getPrefixedDataSet(dataAttributePrefix, $clickedElement)
            };

            trackEvent(data, {debug});
        })
    }
}

function trim(str) {
    return str.replace(/\s\s+/g, ' ').trim();
}

export function responseTracking(request) {
    // Unpack json response body if the promise was created via fetch
    let promise = request.then(response => (response
        && response.json
        && typeof response.json === 'function'
        && response.clone
        && typeof response.clone === 'function')
        ? response.clone().json()
        : response
    );

    promise.then(result => {
        
        // 1. Handle GTM
        if (result['__trackingData'] && Array.isArray(result['__trackingData'])) {
            window.dataLayer = window.dataLayer || [];
            
            result['__trackingData'].forEach(tracker => {
                if (tracker.type === 'gtm') {
                    window.dataLayer.push(tracker.payload);
                }
            });
        }

        // 2. Handle Matomo (Directly from CartController)
        if (result['__matomoData'] && Array.isArray(result['__matomoData'])) {
            window._paq = window._paq || [];
            
            result['__matomoData'].forEach(payload => {
                window._paq.push(payload); 
            });
        }

    }).catch(e => console.error("Tracking Error:", e));
}
